var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.name === 'Login' || _vm.$route.name === 'Register' ? false : true)?_c('div',[_c('Navigation')],1):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }